export const systemIncludes = [
  "6 specialized educational volumes",
  "5 complementary professional resources",
  "Gastrointestinal physiology and digestion references",
  "Nutrition assessment frameworks",
  "Digestive health and dietary consideration guides",
  "Educational clinical case studies",
  "Nutrition care planning worksheets",
  "Documentation and reference organization templates",
];

export const blueprintIncludes = [
  "Six specialized educational volumes",
  "Five professional bonuses",
  "Gastrointestinal physiology reference materials",
  "Nutritional assessment frameworks",
  "Digestive nutrition reference resources",
  "Educational gastrointestinal condition summaries",
  "Nutrition care planning worksheets",
  "Hypothetical clinical case studies",
  "Documentation and reference organization templates",
];

export const sixVolumeList = [
  "Gastrointestinal Physiology & Digestion Guide",
  "GI Nutrition Assessment Blueprint",
  "Gastrointestinal Nutrition & Dietary Reference Guide",
  "GI Nutrition Care Planning Workbook",
  "Gastrointestinal Nutrition Clinical Case Analysis Guide",
  "GI Nutrition Documentation & Reference Organization Guide",
];

export const bonusValues = [
  { name: "Gastrointestinal Physiology Visual Atlas", value: 19 },
  { name: "GI Nutrition Assessment Worksheet Collection", value: 17 },
  { name: "Gastrointestinal Conditions Reference Atlas", value: 19 },
  { name: "GI Nutrition Clinical Casebook", value: 17 },
  { name: "GI Nutrition Documentation & Reference Toolkit", value: 19 },
];
